import { styled } from 'styled-components'

export const AutocompleteWrapper = styled.div`
  padding: ${({ theme }) => theme.spacers[3]};
  background-color: ${({ theme }) => theme.colors.underline};
`
